import React from "react";
import { ErrorBoundary } from "react-error-boundary";


const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div className="d-flex justify-content-center align-items-center vh-100 text-center">
      <div className="card shadow-lg p-4 border-0" style={{ maxWidth: "600px" }}>
        <div className="card-body">
          <h4 className="card-title text-dark">Oops! Something went wrong.</h4>
          <p className="text-muted">An unexpected error occurred.</p>
          <button className="btn btn-primary mt-3" onClick={resetErrorBoundary}>
            Try Again
          </button>
        </div>
      </div>
    </div>
  );
};

const CustomErrorBoundary = ({ children }) => {
  return (
    <ErrorBoundary 
      FallbackComponent={ErrorFallback} 
      onReset={() => window.location.reload()} // Reloads the page when clicking "Try Again"
    >
      {children}
    </ErrorBoundary>
  );
};

export default CustomErrorBoundary;
